import { useAppDispatch } from '../../../../shared/libs/redux';
import { workshopModuleTagApi, workshopTagActions } from '../../../../entities/module/workshop-module-tag';
import { notificationError, notificationSuccess } from '../../../../components/Notifications/callNotifcation';

export const useCreateWorkshopTag = () => {
	const dispatch = useAppDispatch();

	const [createTag, requestData] = workshopModuleTagApi.useCreateMutation();

	const onCreate = async (name: string) => {
		try {
			const res = await createTag({ name })
				.unwrap();
			dispatch(workshopTagActions.setCreateTagName(''));
			dispatch(workshopTagActions.setIsCreateModalActive(false));

			notificationSuccess('Тег создан успешно');

			return res.moduleTag;
		} catch (e) {
			notificationError('Возникла ошибка при создании тега...');

			return null;
		}
	};

	return {
		onCreate,
		requestData,
	};
};
